module.exports = __webpack_public_path__ + "static/media/img-precio-historico.a2d6dd47.jpeg";